import { atom } from "recoil";
import { parseQrContext } from "../../utils/qrContext";

const loadTableIdFromSession = () => {
  try {
    const tableId =
      window.sessionStorage.getItem(
        "tableId"
      );

    if (
      tableId &&
      tableId.length <= 100 &&
      parseQrContext(tableId)
    ) {
      return tableId;
    }
  } catch {
    // Storage may be unavailable.
  }

  return null;
};

export const tableIdState = atom({
  key: "tableIdState",
  default: loadTableIdFromSession(),
});